<template>
  <div class="qr-wrap">
    <canvas
      ref="canvas"
      :width="exportSize"
      :height="exportSize"
      class="qr-canvas"
      :style="{ width: `${size}px`, height: `${size}px` }"
    ></canvas>

    <div v-if="showControls" class="qr-controls">
      <button
        type="button"
        class="btn btn-outline-secondary btn-sm"
        :disabled="!ready"
        @click="downloadPng"
        title="Скачать QR-код в PNG"
      >
        <i class="bi bi-download"></i>
        Скачать PNG
      </button>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode'

export default {
  name: 'QrCode',
  props: {
    value: { type: String, required: true },
    // размер отображения на странице (CSS)
    size: { type: Number, default: 128 },
    // реальное разрешение PNG (canvas) — например 1024x1024 для печати
    exportSize: { type: Number, default: 1024 },
    margin: { type: Number, default: 2 },
    errorCorrectionLevel: { type: String, default: 'M' }, // L/M/Q/H
    fileName: { type: String, default: 'qr-code.png' },
    showControls: { type: Boolean, default: true },
    caption: { type: String, default: '' }
  },
  data() {
    return {
      ready: false
    }
  },
  mounted() {
    this.render()
  },
  watch: {
    value() {
      this.render()
    },
    size() {
      this.render()
    },
    exportSize() {
      this.render()
    },
    margin() {
      this.render()
    },
    errorCorrectionLevel() {
      this.render()
    }
  },
  methods: {
    async render() {
      this.ready = false
      const canvas = this.$refs.canvas
      if (!canvas) return

      try {
        await QRCode.toCanvas(canvas, this.value, {
          width: this.exportSize,
          margin: this.margin,
          errorCorrectionLevel: this.errorCorrectionLevel
        })
        this.ready = true
      } catch (e) {
        console.error('Ошибка генерации QR:', e)
      }
    },
    downloadPng() {
      const src = this.$refs.canvas
      if (!src) return

      const caption = String(this.caption || '').trim()
      let out = src
      if (caption) {
        const pad = Math.round(this.exportSize * 0.28)
        const canvas = document.createElement('canvas')
        canvas.width = this.exportSize
        canvas.height = this.exportSize + pad
        const ctx = canvas.getContext('2d')
        ctx.fillStyle = '#ffffff'
        ctx.fillRect(0, 0, canvas.width, canvas.height)
        ctx.drawImage(src, 0, 0)
        ctx.fillStyle = '#000000'
        ctx.textAlign = 'center'
        ctx.textBaseline = 'middle'
        let fontPx = Math.round(this.exportSize * 0.14)
        ctx.font = `bold ${fontPx}px sans-serif`
        const maxWidth = canvas.width - Math.round(this.exportSize * 0.08)
        while (fontPx > 16 && ctx.measureText(caption).width > maxWidth) {
          fontPx -= 1
          ctx.font = `bold ${fontPx}px sans-serif`
        }
        ctx.fillText(caption, canvas.width / 2, this.exportSize + pad / 2)
        out = canvas
      }

      const dataUrl = out.toDataURL('image/png')
      const link = document.createElement('a')
      link.href = dataUrl
      link.download = this.fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
</script>

<style scoped>
.qr-wrap {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 0.35rem;
}

.qr-canvas {
  image-rendering: pixelated;
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  background: #fff;
}

.qr-controls {
  display: flex;
  gap: 0.5rem;
}
</style>


